import React, { useState, useEffect } from 'react';
import '../styles/UserManagement.css';
import { getAdmins, addAdmin, updateAdmin, deleteAdmin } from '../services/api';

function UserManagement() {
  const [admins, setAdmins] = useState([]);
  const [newAdmin, setNewAdmin] = useState({ username: '', password: '', email: '', role: 'admin' });
  const [editAdmin, setEditAdmin] = useState(null);

  useEffect(() => {
    const fetchAdmins = async () => {
      try {
        const data = await getAdmins();
        setAdmins(data);
      } catch (err) {
        console.error('Failed to fetch admins:', err);
      }
    };
    fetchAdmins();
  }, []);

  const handleAddAdmin = async (e) => {
    e.preventDefault();
    try {
      const response = await addAdmin(newAdmin);
      setAdmins([...admins, response]);
      setNewAdmin({ username: '', password: '', email: '', role: 'admin' });
    } catch (err) {
      alert('Failed to add admin.');
    }
  };

  const handleUpdateAdmin = async (e) => {
    e.preventDefault();
    try {
      await updateAdmin(editAdmin.id, editAdmin);
      setAdmins(admins.map(a => a.id === editAdmin.id ? editAdmin : a));
      setEditAdmin(null);
    } catch (err) {
      alert('Failed to update admin.');
    }
  };

  const handleDeleteAdmin = async (adminId) => {
    if (window.confirm('Are you sure you want to delete this admin?')) {
      try {
        await deleteAdmin(adminId);
        setAdmins(admins.filter(a => a.id !== adminId));
      } catch (err) {
        alert('Failed to delete admin.');
      }
    }
  };

  return (
    <div className="ap-user-management">
      <h2 className="ap-um-title">User Management</h2>
      <form className="ap-add-user-form" onSubmit={handleAddAdmin}>
        <input
          className="ap-um-input"
          name="username"
          placeholder="Username"
          value={newAdmin.username}
          onChange={(e) => setNewAdmin({ ...newAdmin, username: e.target.value })}
          required
        />
        <input
          className="ap-um-input"
          name="password"
          type="password"
          placeholder="Password"
          value={newAdmin.password}
          onChange={(e) => setNewAdmin({ ...newAdmin, password: e.target.value })}
          required
        />
        <input
          className="ap-um-input"
          name="email"
          placeholder="Email"
          value={newAdmin.email}
          onChange={(e) => setNewAdmin({ ...newAdmin, email: e.target.value })}
          required
        />
        <select
          className="ap-um-select"
          name="role"
          value={newAdmin.role}
          onChange={(e) => setNewAdmin({ ...newAdmin, role: e.target.value })}
        >
          <option value="admin">Admin</option>
          <option value="superadmin">Superadmin</option>
        </select>
        <button className="ap-um-btn" type="submit">Add Admin</button>
      </form>
      <div className="ap-user-list">
        {admins.map(admin => (
          <div key={admin.id} className="ap-user-card">
            <h3 className="ap-user-username">{admin.username}</h3>
            <p className="ap-user-email">{admin.email}</p>
            <p className="ap-user-role">Role: {admin.role}</p>
            <button className="ap-edit-btn" onClick={() => setEditAdmin(admin)}>Edit</button>
            <button className="ap-delete-btn" onClick={() => handleDeleteAdmin(admin.id)}>Delete</button>
          </div>
        ))}
      </div>
      {editAdmin && (
        <form className="ap-edit-user-form" onSubmit={handleUpdateAdmin}>
          <h3 className="ap-edit-title">Edit Admin</h3>
          <input
            className="ap-um-input"
            name="username"
            value={editAdmin.username}
            onChange={(e) => setEditAdmin({ ...editAdmin, username: e.target.value })}
            required
          />
          <input
            className="ap-um-input"
            name="password"
            type="password"
            placeholder="New Password (leave blank to keep current)"
            onChange={(e) => setEditAdmin({ ...editAdmin, password: e.target.value })}
          />
          <input
            className="ap-um-input"
            name="email"
            value={editAdmin.email}
            onChange={(e) => setEditAdmin({ ...editAdmin, email: e.target.value })}
            required
          />
          <select
            className="ap-um-select"
            name="role"
            value={editAdmin.role}
            onChange={(e) => setEditAdmin({ ...editAdmin, role: e.target.value })}
          >
            <option value="admin">Admin</option>
            <option value="superadmin">Superadmin</option>
          </select>
          <button className="ap-um-btn" type="submit">Save</button>
          <button className="ap-cancel-btn" type="button" onClick={() => setEditAdmin(null)}>Cancel</button>
        </form>
      )}
    </div>
  );
}

export default UserManagement;